import React, { useEffect, useState, useRef } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useTransition, animated, config } from '@react-spring/web'
import translations from './translations.yml'
import styles from './styles.m.scss'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'

export const CopyToClipboardUrl = ({
  title,
  text,
  url,
  locale,
  buttonColor,
  inverted
}: {
  title: string
  text: string
  url: string
  locale: 'fr' | 'de'
  buttonColor: string
  inverted: boolean
}) => {
  const loc = translations[locale]
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [copied, setCopied] = useState(false)
  const timeout = useRef<NodeJS.Timeout | null>(null)
  const transitions = useTransition(copied && isMobile, {
    from: { opacity: 0, translateY: -10 },
    enter: { opacity: 1, translateY: 0 },
    leave: { opacity: 0, translateY: -10 },
    delay: 200,
    config: config.molasses
  })

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768)
  }

  useEffect(() => {
    if (copied) {
      timeout.current = setTimeout(() => {
        setCopied(false)
      }, 3000)

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'copyurl',
        event_label: `url:${url}`
      })
    }
  }, [copied])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)

      if (timeout.current) {
        clearTimeout(timeout.current)
      }
    }
  }, [])

  return (
    <div className={`ui ${inverted ? 'inverted' : ''} ${styles.container}`}>
      <div className='ui list'>
        <div className='item'>
          <div className={`content ${styles.content}`}>
            <div className={styles.container}>
              <div className='header'>
                {title} <i className='icon share' />
              </div>
              <div>
                <div className={`ui action input ${styles.inputContainer}`}>
                  {transitions(
                    (transitionStyles, item) =>
                      item && (
                        <animated.div
                          style={transitionStyles}
                          className={styles.labelContainer}
                        >
                          <div
                            className={`ui pointing below ${
                              inverted ? 'white' : 'black'
                            } label`}
                          >
                            {loc.copied}!
                          </div>
                        </animated.div>
                      )
                  )}
                  <input
                    type='text'
                    value={url}
                    onChange={() => undefined}
                    className={styles.input}
                  />
                  <CopyToClipboard
                    text={url}
                    onCopy={() => {
                      setCopied(true)
                    }}
                  >
                    <button className='ui teal right labeled icon primary button'>
                      <i className={`${copied ? 'check' : 'copy'} icon`} />
                      {!isMobile && (
                        <div>{copied ? `${loc.copied}!` : loc.copy}</div>
                      )}
                    </button>
                  </CopyToClipboard>
                </div>
              </div>
              <div className={styles.text}>{text}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CopyToClipboardUrl.defaultProps = {
  locale: 'de',
  url: window.location.href,
  inverted: false
}
